import { put, select } from 'redux-saga/effects'
import { selectGameAPIData } from '../selectors'
import * as actions from '../actions'
import { randomizeArray } from '../../../utils/util';


export function* getInferencingData(payload, getGameData) {
    const { from, childSelected, language } = payload;
    // The language setting (from the gear on the student's card; it starts from the student's language): Spanish,
    // Portuguese, French or Italian gets each story, its answers and its recording in that language (question_sp,
    // correct_it… beside the English), where it has one.
    const code = language || childSelected?.language
    const lang = ['sp', 'pt', 'fr', 'it'].includes(code) ? `_${code}` : ''

    let inferencingState = yield select(selectGameAPIData)

    if (!inferencingState) {
        inferencingState = yield* getGameData(
            null,
            null,
            null,
            'INFERENCING',
            from,
            null,
            null
        )
        yield put(actions.setGameData({ apiData: inferencingState }))
    }
    const data = randomizeArray(JSON.parse(JSON.stringify(inferencingState)))
    let displayData = [];
    data.map((english, idx) => {
        const item = lang && english[`question${lang}`]
            ? { ...english, question: english[`question${lang}`], correct: english[`correct${lang}`], wrong1: english[`wrong1${lang}`], wrong2: english[`wrong2${lang}`], audio: english[`audio${lang}`] }
            : english
        return (
            displayData.push({
                ...item,
                answers: randomizeArray([
                    {
                        id: item.id + '1',
                        isVisible: true,
                        isAnswered: false,
                        answerText: item.correct,
                    },
                    {
                        id: item.id + '2',
                        isVisible: true,
                        isAnswered: false,
                        answerText: item.wrong1,
                    },
                    {
                        id: item.id + '3',
                        isVisible: true,
                        isAnswered: false,
                        answerText: item.wrong2,
                    }
                ])
            })
        )
    })
    const metaFieldData = {
        receptiveActiveItemIndex: 0,
        expressiveActiveItemIndex: 0,
        gameType: 1,
        activeAnswers: displayData[0].answers,
        questionsAnswered: [],
    }
    return { displayData, metaFieldData }
}